<template>
  <div class="pre-requisite">
    <md-card>
      <md-card-header>
      <md-card-header-text>
        <div class="md-title">{{ activity_title }} Prerequisites</div>
      </md-card-header-text>
      </md-card-header>
      <md-card-content>
        <p>The following must be taken before you can access {{ activity_title }}</p>
        <ol class="item-list">
          <li
            :key="index"
            v-for="(group, index) in prerequisite"
            class="list-item"
          >
            <span :key="k" v-for="(option, k) in group">
              <a :href="getActivityLink(option.nid)">{{ option.title }}</a>
              <b v-if="k != group.length - 1"> or </b>
            </span>
          </li>
        </ol>
        <p>
          <a
            @click="hasHistory() ? $router.go(-1) : $router.push('/')"
            class="back-link"
          >
            <md-icon>arrow_back</md-icon>
            Return to screen
          </a>
        </p>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
export default {
  name: "Prerequisite",

  data() {
    return {
      activity_title: window.drupalSettings.controller.activity_title,
      prerequisite: window.drupalSettings.controller.prerequisite
    };
  },

  methods: {
    log(msg) {
      console.log(msg);
    },
    getActivityLink(id) {
      return '/activity/' + id;
    },
    hasHistory() {
      return window.history.length > 2;
    }
  }
};
</script>
<style lang="scss">
</style>
